/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Wlanaccess1Inputs */

const de__field_wlanaccess1 = /** @type {(inputs: _Field_Wlanaccess1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WLAN verfügbar`)
};

/**

* @param {_Field_Wlanaccess1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_wlanaccess1 = /** @type {((inputs?: _Field_Wlanaccess1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Wlanaccess1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_wlanaccess1(inputs)
});
export { _field_wlanaccess1 as "_field_wlanAccess" }